import {
  Typography,
  Card,
  CardHeader,
  Divider,
  TableRow,
  TableCell,
  Table,
  TableBody,
} from "@mui/material";
import React from "react";

export default function WallDetail({ props, wall, noteTest, formData }) {
  return (
    <>
      {formData.registrationPeriod === "Before Works" &&
      formData.roomDisposalDependingBeforeWorks === "Stacked Rooms" ? (
        <>
          <Card elevation={0} style={{ marginBottom: "30px" }}>
            {/* <CardHeader action={<MoreMenu />} title="Recent Logs" /> */}
            <CardHeader title="Basic informations" />
            <Divider />

            <Table sx={{ minWidth: 700 }}>
              <TableBody>
                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Registration period
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    <Typography>{formData.registrationPeriod}</Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Room Disposal
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    <Typography>
                      {formData.roomDisposalDependingBeforeWorks}
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Card>
          <Card elevation={0} style={{ marginBottom: "30px" }}>
            {/* <CardHeader action={<MoreMenu />} title="Recent Logs" /> */}
            <CardHeader title="Horizontal wall" />
            <Divider />

            <Table sx={{ minWidth: 700 }}>
              <TableBody>
                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Overlay
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    {formData.horizontalWallOverlay}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Coating
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    {formData.horizontalWallCoating}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Structure
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    {formData.horizontalWallStructure}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Ceiling
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    {formData.horizontalWallCeiling}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell style={{ borderBottom: "none" }}>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Surface
                    </Typography>
                  </TableCell>
                  <TableCell style={{ borderBottom: "none" }} align="right">
                    {formData.horizontalWallSurface} m2
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{ borderBottom: "none" }}>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Additional Notes
                    </Typography>
                  </TableCell>
                  <TableCell style={{ borderBottom: "none" }} align="right">
                    {formData.horizontalWallNotes}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Card>
          <Card elevation={0} style={{ marginBottom: "30px" }}>
            <CardHeader title="Stacked Room 1" />
            <Divider />

            <Table sx={{ minWidth: 700 }}>
              <TableBody>
                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Room's name
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    <Typography>{formData.stackedRoom1Name}</Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Type of room
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    {formData.stackedRoom1TypeOf}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Volume
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    {formData.stackedRoom1Volume}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Lateral wall 1
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    {formData.stackedRoom1LateralWall1}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Lateral wall 2
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    {formData.stackedRoom1LateralWall2}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Lateral wall 3
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    {formData.stackedRoom1LateralWall3}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Lateral wall 4
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    {formData.stackedRoom1LateralWall4}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Card>

          <Card elevation={0} style={{ marginBottom: "30px" }}>
            <CardHeader title="Stacked Room 2" />
            <Divider />

            <Table sx={{ minWidth: 700 }}>
              <TableBody>
                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Room's name
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    <Typography>{formData.stackedRoom2Name}</Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Type of room
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    {formData.stackedRoom2TypeOf}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Volume
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    {formData.stackedRoom2Volume}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Lateral wall 1
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    {formData.stackedRoom2LateralWall1}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Lateral wall 2
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    {formData.stackedRoom2LateralWall2}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Lateral wall 3
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    {formData.stackedRoom2LateralWall3}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Lateral wall 4
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    {formData.stackedRoom2LateralWall4}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Card>
        </>
      ) : formData.registrationPeriod === "Before Works" &&
        formData.roomDisposalDependingBeforeWorks === "Side By Side Rooms" ? (
        <>
          <Card elevation={0} style={{ marginBottom: "30px" }}>
            {/* <CardHeader action={<MoreMenu />} title="Recent Logs" /> */}
            <CardHeader title="Basic informations" />
            <Divider />

            <Table sx={{ minWidth: 700 }}>
              <TableBody>
                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Registration period
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    <Typography>{formData.registrationPeriod}</Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Room Disposal
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    <Typography>
                      {formData.roomDisposalDependingBeforeWorks}
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Card>
          <Card elevation={0} style={{ marginBottom: "30px" }}>
            {/* <CardHeader action={<MoreMenu />} title="Recent Logs" /> */}
            <CardHeader title="Vertical wall" />
            <Divider />

            <Table sx={{ minWidth: 700 }}>
              <TableBody>
                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Coating Side Room 1
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    {formData.verticalWallCoatingSideRoom1}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Structure
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    {formData.verticalWallStructure}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Coating Side Room 2
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    {formData.verticalWallCoatingSideRoom2}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Surface
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    {formData.verticalWallSurface}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell style={{ borderBottom: "none" }}>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Additional Notes
                    </Typography>
                  </TableCell>
                  <TableCell style={{ borderBottom: "none" }} align="right">
                    {formData.verticalWallNotes}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Card>
          <Card elevation={0} style={{ marginBottom: "30px" }}>
            <CardHeader title="Stacked Room 1" />
            <Divider />

            <Table sx={{ minWidth: 700 }}>
              <TableBody>
                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Room's name
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    <Typography>{formData.sideRoom1Name}</Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Type of room
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    {formData.sideRoom1TypeOf}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Volume
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    {formData.sideRoom1Volume}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Lateral wall 1
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    {formData.sideRoom1LateralWall1}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Lateral wall 2
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    {formData.sideRoom1LateralWall2}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Ceiling
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    {formData.sideRoom1Ceiling}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Structure
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    {formData.sideRoom1CeilingStructure}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Floor Coating
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    {formData.sideRoom1FloorCoating}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Floor Structure
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    {formData.sideRoom1FloorStructure}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Additional Notes
                    </Typography>
                  </TableCell>
                  <TableCell align="right">{formData.sideRoom1Notes}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Card>

          <Card elevation={0} style={{ marginBottom: "30px" }}>
            <CardHeader title="Stacked Room 2" />
            <Divider />

            <Table sx={{ minWidth: 700 }}>
              <TableBody>
                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Room's name
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    <Typography>{formData.sideRoom2Name}</Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Type of room
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    {formData.sideRoom2TypeOf}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Volume
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    {formData.sideRoom2Volume}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Lateral wall 1
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    {formData.sideRoom2LateralWall1}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Lateral wall 2
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    {formData.sideRoom2LateralWall2}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Ceiling
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    {formData.sideRoom2Ceiling}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Ceiling Structure
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    {formData.sideRoom2CeilingStructure}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Floor Coating
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    {formData.sideRoom2FloorCoating}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Floor Structure
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    {formData.sideRoom2FloorStructure}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Additional Notes
                    </Typography>
                  </TableCell>
                  <TableCell align="right">{formData.sideRoom2Notes}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Card>
        </>
      ) : formData.registrationPeriod === "After Works" &&
        formData.roomDisposalDependingAfterWorks === "Stacked Rooms" ? (
        <>
          <Card elevation={0} style={{ marginBottom: "30px" }}>
            {/* <CardHeader action={<MoreMenu />} title="Recent Logs" /> */}
            <CardHeader title="Basic informations" />
            <Divider />

            <Table sx={{ minWidth: 700 }}>
              <TableBody>
                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Registration period
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    <Typography>{formData.registrationPeriod}</Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Room Disposal
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    <Typography>
                      {formData.roomDisposalDependingAfterWorks}
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Card>
          <Card elevation={0} style={{ marginBottom: "30px" }}>
            {/* <CardHeader action={<MoreMenu />} title="Recent Logs" /> */}
            <CardHeader title="Horizontal wall" />
            <Divider />

            <Table sx={{ minWidth: 700 }}>
              <TableBody>
                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Overlay
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    {formData.horizontalWallOverlay}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Coating
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    {formData.horizontalWallCoating}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Structure
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    {formData.horizontalWallStructure}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Ceiling
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    {formData.horizontalWallCeiling}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell style={{ borderBottom: "none" }}>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Surface
                    </Typography>
                  </TableCell>
                  <TableCell style={{ borderBottom: "none" }} align="right">
                    {formData.horizontalWallSurface} m2
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{ borderBottom: "none" }}>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Additional Notes
                    </Typography>
                  </TableCell>
                  <TableCell style={{ borderBottom: "none" }} align="right">
                    {formData.horizontalWallNotes}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Card>
          <Card elevation={0} style={{ marginBottom: "30px" }}>
            <CardHeader title="Stacked Room 1" />
            <Divider />

            <Table sx={{ minWidth: 700 }}>
              <TableBody>
                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Room's name
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    <Typography>{formData.stackedRoom1Name}</Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Type of room
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    {formData.stackedRoom1TypeOf}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Volume
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    {formData.stackedRoom1Volume}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Lateral wall 1
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    {formData.stackedRoom1LateralWall1}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Lateral wall 2
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    {formData.stackedRoom1LateralWall2}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Lateral wall 3
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    {formData.stackedRoom1LateralWall3}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Lateral wall 4
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    {formData.stackedRoom1LateralWall4}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Card>

          <Card elevation={0} style={{ marginBottom: "30px" }}>
            <CardHeader title="Stacked Room 2" />
            <Divider />

            <Table sx={{ minWidth: 700 }}>
              <TableBody>
                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Room's name
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    <Typography>{formData.stackedRoom2Name}</Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Type of room
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    {formData.stackedRoom2TypeOf}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Volume
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    {formData.stackedRoom2Volume}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Lateral wall 1
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    {formData.stackedRoom2LateralWall1}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Lateral wall 2
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    {formData.stackedRoom2LateralWall2}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Lateral wall 3
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    {formData.stackedRoom2LateralWall3}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Lateral wall 4
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    {formData.stackedRoom2LateralWall4}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Card>
        </>
      ) : formData.registrationPeriod === "After Works" &&
        formData.roomDisposalDependingAfterWorks === "Side By Side Rooms" ? (
        <>
          <Card elevation={0} style={{ marginBottom: "30px" }}>
            {/* <CardHeader action={<MoreMenu />} title="Recent Logs" /> */}
            <CardHeader title="Basic informations" />
            <Divider />

            <Table sx={{ minWidth: 700 }}>
              <TableBody>
                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Registration period
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    <Typography>{formData.registrationPeriod}</Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Room Disposal
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    <Typography>
                      {formData.roomDisposalDependingAfterWorks}
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Card>
          <Card elevation={0} style={{ marginBottom: "30px" }}>
            {/* <CardHeader action={<MoreMenu />} title="Recent Logs" /> */}
            <CardHeader title="Vertical wall" />
            <Divider />

            <Table sx={{ minWidth: 700 }}>
              <TableBody>
                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Coating Side Room 1
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    {formData.verticalWallCoatingSideRoom1}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Structure
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    {formData.verticalWallStructure}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Coating Side Room 2
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    {formData.verticalWallCoatingSideRoom2}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Surface
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    {formData.verticalWallSurface}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell style={{ borderBottom: "none" }}>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Additional Notes
                    </Typography>
                  </TableCell>
                  <TableCell style={{ borderBottom: "none" }} align="right">
                    {formData.verticalWallNotes}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Card>
          <Card elevation={0} style={{ marginBottom: "30px" }}>
            <CardHeader title="Stacked Room 1" />
            <Divider />

            <Table sx={{ minWidth: 700 }}>
              <TableBody>
                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Room's name
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    <Typography>{formData.sideRoom1Name}</Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Type of room
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    {formData.sideRoom1TypeOf}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Volume
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    {formData.sideRoom1Volume}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Lateral wall 1
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    {formData.sideRoom1LateralWall1}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Lateral wall 2
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    {formData.sideRoom1LateralWall2}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Ceiling
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    {formData.sideRoom1Ceiling}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Structure
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    {formData.sideRoom1CeilingStructure}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Floor Coating
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    {formData.sideRoom1FloorCoating}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Floor Structure
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    {formData.sideRoom1FloorStructure}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Additional Notes
                    </Typography>
                  </TableCell>
                  <TableCell align="right">{formData.sideRoom1Notes}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Card>

          <Card elevation={0} style={{ marginBottom: "30px" }}>
            <CardHeader title="Stacked Room 2" />
            <Divider />

            <Table sx={{ minWidth: 700 }}>
              <TableBody>
                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Room's name
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    <Typography>{formData.sideRoom2Name}</Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Type of room
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    {formData.sideRoom2TypeOf}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Volume
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    {formData.sideRoom2Volume}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Lateral wall 1
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    {formData.sideRoom2LateralWall1}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Lateral wall 2
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    {formData.sideRoom2LateralWall2}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Ceiling
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    {formData.sideRoom2Ceiling}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Ceiling Structure
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    {formData.sideRoom2CeilingStructure}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Floor Coating
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    {formData.sideRoom2FloorCoating}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Floor Structure
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    {formData.sideRoom2FloorStructure}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="caption"
                      fontSize="inherit"
                    >
                      Additional Notes
                    </Typography>
                  </TableCell>
                  <TableCell align="right">{formData.sideRoom2Notes}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Card>
        </>
      ) : (
        "error"
      )}
    </>
  );
}
